import React from 'react';
import { Modal } from '@odin-labs/components';
import { TempBadge } from 'containers/jobsite/tabs/jobsiteTempBadges/types';

export function ViewTempBadgeModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  onClosed?: () => void;
  tempBadge: TempBadge;
}): React.ReactElement {
  const { isOpen, closeModal, onClosed, tempBadge: badge } = props;

  return (
    <Modal
      actionsPanel={null}
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      title="Temporary Badge"
      variant="drawer"
      size="xs"
    >
      <div className="odin-space-y-5">
        <p>Badge name</p>
        <p>{badge?.name || '—'}</p>
        <p>Card number</p>
        <p>{badge?.cardNumber || '—'}</p>
      </div>
    </Modal>
  );
}
